import { Submit, Footer } from './Submit';
import { Field } from './Field';
import { Data } from './Data';
import { ErrorCollector } from './ErrorCollector';
export const OtherMap = {
  Submit,
  Field,
  Footer,
  Data,
  ErrorCollector
};
//# sourceMappingURL=es/Other/OtherMap.js.map